/* Compartir AROL: módulo independiente, sin tocar handlers de compra/galería/SKU. */
(function () {
  'use strict';
  if (window.arolProductShareLoaded) return;
  window.arolProductShareLoaded = true;
  var storageKey = 'arol-product-share:v1';
  var media = window.matchMedia('(max-width:640px)');
  function init(root) {
    if (root.dataset.shareInitialized) return;
    var section = root.closest('[data-section-type="product"]');
    if (!section) return;
    var data;
    try { data = JSON.parse(root.querySelector('[data-share-data]').textContent); } catch (_) { return; }
    root.dataset.shareInitialized = 'true';
    var trigger = root.querySelector('.arol-share-trigger'), panel = root.querySelector('.arol-share-panel');
    var backdrop = root.querySelector('.arol-share-backdrop'), status = root.querySelector('.arol-share-status');
    var priceInput = root.querySelector('[data-share-price]');
    var wa = root.querySelector('[data-share-whatsapp]');
    var prefs = { price: false }, current = data.selected, timer, oldOverflow;
    try { var saved = JSON.parse(localStorage.getItem(storageKey)); if (saved && typeof saved.price === 'boolean') prefs.price = saved.price; } catch (_) {}
    priceInput.checked = data.priceAllowed && prefs.price;
    var buy = section.querySelector('.product-form__add-button');
    if (buy && !buy.closest('[hidden]') && buy.getBoundingClientRect().height) {
      var row = buy.closest('.product-form__payment-container');
      if (row) { root.style.setProperty('--arol-share-height', buy.getBoundingClientRect().height + 'px'); row.classList.add('arol-share-paired'); root.classList.add('arol-share-in-buy'); row.appendChild(root); }
    }
    // Cotización primero; Compartir secundario, sin alterar su enlace o mensaje.
    if (!root.classList.contains('arol-share-in-buy')) {
      var quote = section.querySelector('[data-arol-wa-product].arol-wa-line--quote');
      if (quote) {
        var actions = document.createElement('div'); actions.className = 'arol-share-quote-actions';
        quote.parentNode.insertBefore(actions, quote); actions.appendChild(quote); actions.appendChild(root);
        root.classList.add('arol-share-in-quote');
      }
    }
    root.hidden = false;
    function variant() { return data.variants.find(function (v) { return String(v.id) === String(current); }) || data.variants[0] || {}; }
    function message() {
      var v = variant(), lines = [], sku = String(v.sku || '').trim();
      if (sku) lines.push(sku);
      lines.push(data.title);
      if (data.priceAllowed && priceInput.checked && typeof v.price === 'number') lines.push('$' + new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v.price / 100) + ' MXN');
      // El enlace siempre acompaña al texto, incluso si la preferencia antigua era false.
      { var url = new URL(data.url, location.origin); url.search = ''; url.hash = ''; url.searchParams.set('utm_source', 'compartir'); lines.push(url.href); }
      return lines.join('\n');
    }
    function update() { wa.href = 'https://wa.me/?text=' + encodeURIComponent(message()); }
    function notify(text, long) { clearTimeout(timer); status.textContent = text; timer = setTimeout(function () { status.textContent = ''; }, long ? 6500 : 1800); }
    function close() {
      var returnFocus = panel.contains(document.activeElement);
      panel.hidden = true; backdrop.hidden = true; trigger.setAttribute('aria-expanded', 'false'); panel.setAttribute('aria-hidden', 'true');
      if (oldOverflow !== undefined) { document.documentElement.style.overflow = oldOverflow; oldOverflow = undefined; }
      if (returnFocus) trigger.focus();
    }
    async function copyText(text) {
      try { if (!navigator.clipboard || !navigator.clipboard.writeText) throw Error('Portapapeles no disponible'); await navigator.clipboard.writeText(text); }
      catch (e) {
        var area = document.createElement('textarea'); area.value = text; area.style.cssText = 'position:fixed;left:-9999px;top:0'; document.body.appendChild(area); area.select();
        var ok = false; try { ok = document.execCommand('copy'); } finally { area.remove(); }
        if (!ok) throw e;
      }
    }
    trigger.addEventListener('click', function () {
      if (!panel.hidden) { close(); return; }
      update(); panel.hidden = false; panel.classList.toggle('arol-share-panel--above', !media.matches && trigger.getBoundingClientRect().bottom + panel.offsetHeight + 16 > innerHeight - 72); panel.setAttribute('aria-hidden', 'false'); trigger.setAttribute('aria-expanded', 'true');
      if (media.matches) { backdrop.hidden = false; oldOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; }
      (priceInput.disabled ? root.querySelector('[data-share-action="text"]') : priceInput).focus();
    });
    [priceInput].forEach(function (input) { input.addEventListener('change', function () { prefs.price = data.priceAllowed ? priceInput.checked : prefs.price; try { localStorage.setItem(storageKey, JSON.stringify(prefs)); } catch (_) {} update(); }); });
    root.querySelector('[data-share-close]').addEventListener('click', function () { close(); trigger.focus(); });
    backdrop.addEventListener('click', function () { close(); trigger.focus(); });
    document.addEventListener('pointerdown', function (e) { if (!panel.hidden && !root.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); trigger.focus(); }
      if (e.key === 'Tab') { var controls = Array.from(panel.querySelectorAll('button:not(:disabled),input:not(:disabled),a[href]')).filter(function (x) { return x.getBoundingClientRect().height; }); if (!controls.length) return; if (e.shiftKey && document.activeElement === controls[0]) { e.preventDefault(); controls[controls.length - 1].focus(); } else if (!e.shiftKey && document.activeElement === controls[controls.length - 1]) { e.preventDefault(); controls[0].focus(); } }
    });
    root.querySelectorAll('[data-share-action]').forEach(function (button) { button.addEventListener('click', async function () {
      var action = button.dataset.shareAction, text = message();
      try {
        if (action === 'text') { await copyText(text); close(); notify('Copiado'); }

      } catch (error) { if (error.name === 'AbortError') notify('Compartir cancelado'); else { notify('No se pudo copiar. Usa «Abrir WhatsApp con el texto».', true); console.warn('[AROL Compartir]', error.message); } }
    }); });
    document.addEventListener('variant:changed', function (e) { if (e.target.closest && e.target.closest('[data-section-type="product"]') === section && e.detail && e.detail.variant) { current = e.detail.variant.id; update(); } });
    window.addEventListener('pagehide', close);
    update();
  }
  function start(scope) { scope.querySelectorAll('[data-arol-share]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); }); else start(document);
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
